export default __webpack_public_path__ + "static/media/metro.1c566e13.svg";